import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { dateFormat } from '@app/shared/formatters';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import { AlterarKmModel } from '@data/alterar-km/models';
import { EditarKmComponent } from '@modules/alterar-km/components/editar-km/editar-km.component';
import { AlterarKmController } from '@modules/alterar-km/controllers';
import { modal } from '@shared/alerts/modal/modal.alert';

@Component({
  selector: 'app-alterar-km',
  templateUrl: './alterar-km.component.html',
  styleUrls: ['./alterar-km.component.scss'],
})
export class AlterarKmComponent extends BaseListagemComponent<AlterarKmModel> {
  filtros: Campo[] = [
    {
      name: 'contratos.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      icon: 'insert_drive_file',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'atualizacoesKm.data',
      label: 'Data de Atualização',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [],
    },
    {
      name: 'planosManutencao.dataPrevista',
      label: 'Data Próx. Revisão',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [],
    },
  ];

  protected acoes: Acao[] = [];

  public colunas: Coluna[] = [
    { name: 'numeroGrupoContrato', label: 'Contrato Master' },
    { name: 'placa', label: 'Placa' },
    { name: 'tipoContrato', label: 'Tipo Contrato' },
    { name: 'modelo', label: 'Modelo' },
    { name: 'situacao', label: 'Situação' },
    { name: 'kmAtual', label: 'Km Atual' },
    { name: 'dataAtualizacaoKm', label: 'Data Atualização do Km', format: dateFormat },
    { name: 'proxRevisaoKm', label: 'Prox. Revisão (Km)' },
    { name: 'proxRevisaoIdade', label: 'Prox. Revisão (Idade)' },
    { name: 'proxRevisaoData', label: 'Prox. Revisão (Data)', format: dateFormat },
    { name: 'idadeVeiculo', label: 'Idade do Veículo' },
    { name: 'franquiaKM', label: 'Franquia Km' },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Editar Km',
          icon: 'edit',
          action: this.alterarKm.bind(this),
        },
      ],
    },
  ];

  constructor(public alterarKmController: AlterarKmController, private dialog: MatDialog) {
    super('Alterar Km - Portal do Cliente', alterarKmController);
    this.currentSearchQuery = 'statusId=1';
  }

  public override filtrar(search?: string): void {
    if (search !== undefined) {
      const newSearch = search ? `${search}&statusId=1` : 'statusId=1';
      return super.filtrar(newSearch);
    }

    return super.filtrar();
  }

  protected alterarKm(veiculo: any) {
    const ref = this.dialog.open(EditarKmComponent, {
      width: '500px',
      height: '350px',
      disableClose: true,
      data: {
        codigoVeiculo: veiculo.codigoVeiculo,
        placa: veiculo.placa,
        kmAtual: veiculo.kmAtual,
      },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.filtrar();

        modal.fire({
          title: 'Sucesso!',
          text: 'Km atualizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });
      }
    });
  }
}
